/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Order_Payment_2Inputs */

const vi_carrier_order_payment_2 = /** @type {(inputs: Carrier_Order_Payment_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người nhận trả tiền hàng và cước`)
};

/**

* @param {Carrier_Order_Payment_2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_order_payment_2 = /** @type {((inputs?: Carrier_Order_Payment_2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Order_Payment_2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_order_payment_2(inputs)
});